import { render, staticRenderFns } from "./FuncionariosDemitidos.vue?vue&type=template&id=4f3d3da8"
import script from "./FuncionariosDemitidos.vue?vue&type=script&lang=js"
export * from "./FuncionariosDemitidos.vue?vue&type=script&lang=js"
import style0 from "./FuncionariosDemitidos.vue?vue&type=style&index=0&id=4f3d3da8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports